import React, { Component } from 'react';

import { Polyline } from 'google-maps-react';



class CountryBorder extends Component {

    componentDidMount() {
        this.loadCountryBorder();
    }

    shouldComponentUpdate(nextProps){
        return this.props.showCountryBorder !== nextProps.showCountryBorder || this.props.borderPath !== nextProps.borderPath;
    }

    componentDidUpdate(){
        this.loadCountryBorder();
    }

    loadCountryBorder = () => {

        let result;

        if(this.props.showCountryBorder){
            result = <Polyline
                key={'NatinalBorders'}
                path={this.props.borderPath}
                name={'NatinalBorders'}
                strokeOpacity={0.3}
                strokeColor={'#0000FF'}
                strokeWeight={7}
            />
        }

        this.props.sendChildElementDataToState(this.props.stateElementName, result);
    }

    render(){
        return null;
    }
};


export default CountryBorder;